/**
 * Response model for fixture menu
 */
export default class FixtureMenuModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Sport|Category|Tournament|Match ID
     * @type {number}
     */
    this.id = data.id;
    /**
     * Sport|Category|Tournament|Match Name
     * @type {*|string}
     */
    this.name = data.n;
    /**
     * Sport|Category|Tournament|Match Num of Items
     * @type {number}
     */
    this.numberOfItems = data.ni;
    /**
     * Sport|Category|Tournament|Match items
     * @type {boolean}
     */
    this.items = [];
    /**
     * Sport|Category|Tournament| Icon class
     * @type {string}
     */
    this.class = data.c;
    /**
     * Name Type  0=Sport | 1=Category | 2=CategoryGroup | 3=Tournament | 4=TournamentGroup
     * @type {number}
     */
    this.cType = data.t;
    /**
     * Sport|Category|Tournament| selected sport
     * @type {string}
     */
    this.selected = false;
    /**
     * Number of markets
     * @type {number}
     */
    this.numberOfMarkets = data.nm;
    /**
     * Number of outrights
     * @type {number}
     */
    this.numberOfOutrights = data.no;
    /**
     * Number of category level outrights
     * @type {number}
     */
    this.numberOfCategoryOutrights = data.nco;
    /**
     * Total number of odds (markets + outrights)
     * @type {number}
     */
    this.totalNumberOfOdds = data.ni;
    /**
     * Shows cashout availabilty in tournaments
     * @type {boolean}
     */
    this.cashOutVisibility = data.cs;
    /**
     * Category name when cType is CategoryGroup
     * @type {string}
     */
    this.parentName = data.pn;
  }
}
